import { useState } from "react";
import TheaterComedyIcon from "@mui/icons-material/TheaterComedy";
import { Divider, IconButton, Menu, Tooltip } from "@mui/material";
import DebugInfo from "src/business-components/general/DebugInfo/DebugInfo";
import { useCurrentUser } from "src/business-hooks/useCurrentUser";
import UserAvatar from "src/components/UserAvatar/UserAvatar";
import useBooleanState from "src/hooks/useBooleanState";
import { useIsImpersonated } from "src/super-admin/SuperAdmin.utils";
import GenerateTokenForm from "../SystemSettings/components/GenerateTokenForm/GenerateTokenForm";
import TopbarUserActions from "./components/TopbarUserActions/TopbarUserActions";
import TopbarUserAdminActions from "./components/TopbarUserAdminActions/TopbarUserAdminActions";
import TopbarUserInfo from "./components/TopbarUserInfo/TopbarUserInfo";

export default function TopbarUser() {
  const user = useCurrentUser();
  const isImpersonated = useIsImpersonated();
  const [personMenuAnchor, setPersonMenuAnchor] = useState<HTMLElement | null>(null);
  const generateTokenModalState = useBooleanState(false);

  const closeMenu = () => setPersonMenuAnchor(null);

  return (
    <>
      <Tooltip title="User">
        <IconButton
          onClick={(event) => setPersonMenuAnchor(event.currentTarget)}
          data-test-id="topbar-user-button"
          data-ph-capture-attribute-action="open_user_menu"
        >
          {isImpersonated ? (
            <TheaterComedyIcon fontSize="large" color="primary" />
          ) : (
            <UserAvatar user={user} />
          )}
        </IconButton>
      </Tooltip>

      <Menu
        id="menu-appbar"
        anchorEl={personMenuAnchor}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{ paper: { sx: { minWidth: 240 } } }}
        open={Boolean(personMenuAnchor)}
        onClose={closeMenu}
      >
        <TopbarUserInfo />
        <Divider />
        <TopbarUserActions
          onGenerateToken={() => {
            generateTokenModalState.show();
            closeMenu();
          }}
        />
        <TopbarUserAdminActions />
        <Divider />
        <DebugInfo />
      </Menu>

      <GenerateTokenForm
        open={generateTokenModalState.visible}
        onClose={generateTokenModalState.hide}
      />
    </>
  );
}
